// Stable per-browser installation id used for the per-code device cap.
// Random (not a fingerprint); a privacy-safe UUID persisted in localStorage.
const KEY = "bnm-device-id";

export function getDeviceId() {
  try {
    const existing = window.localStorage.getItem(KEY);
    if (existing && /^[0-9a-f-]{36}$/i.test(existing)) return existing;
    const id =
      window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          });
    window.localStorage.setItem(KEY, id);
    return id;
  } catch (e) {
    return "00000000-0000-4000-8000-000000000000";
  }
}
